import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { errorHandling } from "../../helper";

const termSlice = createSlice({
  name: "termSlice",
  initialState: {
    loading: false,
    termsDetails: {},
    privacyPageDetails: {},
  },
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    getDetails: (state, action) => {
      state.termsDetails = action.payload?.TermsAndConditions;
    },
    getPrivacyDetails: (state, action) => {
      state.privacyPageDetails = action.payload.PrivacyPolicy;
    },
  },
});

export const { loading, getDetails, getPrivacyDetails } = termSlice.actions;

export const getTermsDetails = () => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_terms_conditions`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(getDetails(data));
    dispatch(loading(false));
  } catch (error) {
    toast.error(error.response.data.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const createTerms = (pData) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_terms_conditions`;
    const { data } = await axios.post(url, pData, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    toast("Terms and conditions updated successfully");
    dispatch(loading(false));
  } catch (error) {
    toast.error(error.response.data.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const createPrivacyPolicy = (pData) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_privacy_policy`;
    const { data } = await axios.post(url, pData, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    toast("Privacy policy updated successfully");

    dispatch(loading(false));
  } catch (error) {
    toast.error(error?.response?.data?.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const getPrivacyPageDetails = () => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_privacy_policy`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(getPrivacyDetails(data));
    dispatch(loading(false));
  } catch (error) {
    toast.error(error.response.data.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};
export default termSlice.reducer;
